import { useContext } from 'react'
import PropTypes from 'prop-types'
import { Navigate, useLocation } from 'react-router-dom'
import { AppContext } from './AppContext.tsx'
import LoadingScreen from './LoadingScreen.jsx'

/**
 * Protects a route by redirecting to /login if the user is not authenticated
 * or to /onboarding if they haven't completed onboarding.
 */
const ProtectedRoute = ({ children }) => {
  const { authSession, authLoading, initializingUI, profile } = useContext(AppContext)
  const location = useLocation()
  
  // Get time-based greeting
  const getGreeting = () => {
    const hour = new Date().getHours()
    if (hour < 12) return 'Good morning'
    if (hour < 18) return 'Good afternoon'
    return 'Good evening'
  }
  
  // Show loading screen during initial auth check
  if (authLoading) {
    return <LoadingScreen title={getGreeting()} />
  }

  // Show loading screen while fetching app data for authenticated user
  if (authSession && initializingUI) {
    return <LoadingScreen title={getGreeting()} subtitle="Setting everything up..." />
  }
  
  // Redirect to login if not authenticated
  if (!authSession) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }
  
  // Check if profile is loaded and onboarding is not completed
  if (profile && !profile.has_completed_onboarding) {
    return <Navigate to="/onboarding" replace />
  }
  
  return children
}

ProtectedRoute.propTypes = {
  children: PropTypes.node.isRequired,
}

export default ProtectedRoute